module.exports = __webpack_public_path__ + "static/media/threeDot.f4507e40.svg";